// extracted by mini-css-extract-plugin
module.exports =  {"header":"R1azMQfK78u9C6DD2Snq"};